import { Injectable } from '@angular/core';
import { EventDetails, EventTeamRegistration, EventUserRegistration, Events } from '@app/events/models';
import { HttpService } from '@core/services';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  constructor(private httpService: HttpService) {}

  public getEvents(): Observable<Events> {
    return this.httpService.get<Events>('/public/Events').pipe(
      map(({ upcoming, past }) => ({
        upcoming: upcoming.sort((a, b) => a.startDate.local.localeCompare(b.startDate.local)),
        past: past.sort((a, b) => b.startDate.local.localeCompare(a.startDate.local)),
      }))
    );
  }

  public getEventById(id: number): Observable<EventDetails> {
    return this.httpService.get<EventDetails>(`/public/Events/${id}`);
  }

  public registration(id: number, playerRegistration: EventTeamRegistration[]): Observable<void> {
    return this.httpService.post(`/public/Events/${id}/register`, { playerRegistration });
  }

  public deleteRegistration(id: number): Observable<void> {
    return this.httpService.delete(`/public/Events/${id}/participate`);
  }

  public getUserEventRegistrations(): Observable<EventUserRegistration[]> {
    return this.httpService.get('/public/events/registrations');
  }
}
